import { TabRowInterface } from '../../shared/component/side-config-bar/side-config-bar.model';

export interface UserConfigurationStateInterface {
  userConfigurationDataLoading: boolean;
  userConfigurationDataLoaded: boolean;
  userConfigurationData: IUserConfiguration;
  temporaryMode: boolean;
  colorBlindMode: boolean;
}

export interface IUserConfigurationResponse {
  colorBlindMode: boolean;
  configuration: IUserConfiguration | null;
}

export interface IComponentConfiguration {
  name: string;
  value?: {name: ConfigurationValueDataTypes, type: string;}[];
  children?: IComponentConfiguration[];
}

export type IUserConfiguration = {
  [key in ComponentNamesForUserConfiguration]?: IComponentConfiguration[];
};

export type ConfigurationValueDataTypes = string | string[] | number | number[] | boolean | TabRowInterface[];

export enum ComponentNamesForUserConfiguration {
  DeviceManagement = 'DeviceManagementComponent',
  UserSettings = 'UserSettingsComponent',
}
